import * as React from 'react';
import { Helmet } from 'react-helmet';
import segment from "../segment";

import Posts from "./components/Posts";
import CallToAction from "./components/CallToAction";

class News extends React.Component {

    componentDidMount() {
        segment.page('Home');
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Latest News - Speedweaver</title>
                    <meta name="description" content="Chiptuning software built for the 21st Century. From fully automated tuning in under 90 seconds to our advanced browser-based file editor." />
                    <meta property="og:title" content="Latest News - Speedweaver" />
                    <meta property="og:description" content="Chiptuning software built for the 21st Century. From fully automated tuning in under 90 seconds to our advanced browser-based file editor." />
                    <meta property="og:image" content="https://speedweaver.co.uk/og.png" />
                </Helmet>

                <header className="container ">
                    <h1>Latest News</h1>
                </header>

                <Posts tag={"news"} limit={null} />

                <CallToAction />
            </>
        );
    }
}

export default News;
